import { useEffect } from 'react';

/**
 * Hook to lock the body scroll.
 * @param {boolean} locked - Whether the scroll should be locked.
 */
export function useLockBodyScroll(locked = true) {
  useEffect(() => {
    if (locked) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      
      return () => {
        document.body.style.overflow = originalStyle === 'hidden' ? 'unset' : originalStyle;
      };
    } else {
        // If explicitly unlocked or toggled off, ensure we reset (or do nothing if we want to respect external control, but typically we want to unset what we set)
        // For simple toggling in modal:
        document.body.style.overflow = 'unset';
    }
  }, [locked]);
}
